<template>
  <div>
    <v-container class="py-0">
      <div class="d-flex align-center justify-space-between py-4 py-sm-7">
        <router-link to="/">
          <img
            src="../assets/img/control-p-sinop.png"
            class="d-block"
            :height="xsOnly ? '60px' : '128px'"
          />
        </router-link>

        <div class="d-flex" style="gap: 10px">
          <v-btn
            v-for="({ text, link, icon }, keySocial) in social"
            :key="keySocial"
            :href="link"
            target="_blank"
            :title="text"
            color="primary"
            :height="xsOnly ? '40px' : '75px'"
            :width="xsOnly ? '40px' : '75px'"
            depressed
            x-large
            fab
          >
            <v-icon color="black" :size="xsOnly ? 20 : 40">
              {{ icon }}
            </v-icon>
          </v-btn>
        </div>
      </div>
    </v-container>

    <SlideShowSection />

    <ServicesSection />
  </div>
</template>

<script>
import SlideShowSection from "../components/sections/SlideShowSection.vue";
import ServicesSection from "../components/sections/ServicesSection.vue";

const _data = {
  social: [
    {
      text: "WhatsApp",
      link: "//wa.me/556635324172",
      icon: "fab fa-whatsapp",
    },
    {
      text: "Instagram",
      link: "https://www.instagram.com/controlpsinop",
      icon: "fab fa-instagram",
    },
    {
      text: "Google Maps",
      link: "https://maps.app.goo.gl/r6oQUkcpArro5q1o8",
      icon: "fa-map-marker-alt",
    },
  ],
};

export default {
  data: () => ({
    ..._data,
  }),
  computed: {
    xsOnly() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  components: {
    SlideShowSection,
    ServicesSection,
  },
};
</script>
